module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Coffee2-bc229ad8e5aad57e7bf7c66ad14de2b7.svg";